/* ProEgg storefront behaviour: countdown, waitlist tags and referrals, "You're on the list" page,
   product gallery, quantity, flavour quiz, bundle builder. */
(() => {
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Browser storage can be switched off; the site still works without it.
  const storage = (area) => ({
    get(key) {
      try {
        return window[area].getItem(key) || '';
      } catch (e) {
        return '';
      }
    },
    set(key, value) {
      try {
        window[area].setItem(key, value);
      } catch (e) {}
    },
    remove(key) {
      try {
        window[area].removeItem(key);
      } catch (e) {}
    },
  });
  const local = storage('localStorage');
  const session = storage('sessionStorage');
  const params = new URLSearchParams(window.location.search);
  const FLAVOURS = ['plain', 'strawberry', 'banana', 'caramel'];

  /* A saved bundle is "banana:2,plain:1": flavour keys with 1 to 4 bags, at most 4 bags in all */
  function parseBundle(value) {
    const picks = {};
    let total = 0;
    String(value || '')
      .split(',')
      .forEach((part) => {
        const [key, qty] = part.split(':');
        const n = parseInt(qty, 10);
        if (FLAVOURS.includes(key) && n > 0 && n <= 4) {
          picks[key] = (picks[key] || 0) + n;
          total += n;
        }
      });
    return total > 0 && total <= 4 ? picks : null;
  }
  const bundleString = (picks) =>
    Object.keys(picks)
      .map((key) => `${key}:${picks[key]}`)
      .join(',');

  /* Referral codes. Every waitlist signup gets a short code (customer tag "ref-CODE"). Their share
     link is the home page with ?ref=CODE, and friends who join from it are tagged "referred-by-CODE". */
  const CODE = /^[A-Z0-9]{4,12}$/;
  function myCode() {
    let code = local.get('pe_ref_code');
    if (!CODE.test(code)) {
      const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
      const bytes = window.crypto.getRandomValues(new Uint8Array(6));
      code = Array.from(bytes, (b) => chars[b % chars.length]).join('');
      local.set('pe_ref_code', code);
    }
    return code;
  }
  const incomingRef = (params.get('ref') || '').toUpperCase();
  if (CODE.test(incomingRef) && incomingRef !== local.get('pe_ref_code')) local.set('pe_referred_by', incomingRef);
  const referredBy = () => {
    const ref = local.get('pe_referred_by');
    return CODE.test(ref) && ref !== local.get('pe_ref_code') ? ref : '';
  };
  if (referredBy() && !local.get('pe_joined')) $$('[data-pe-invited]').forEach((note) => (note.hidden = false));

  // Remember what someone picked, for their pass on the "You're on the list" page
  function rememberJoin(form) {
    const flavour = form && form.querySelector('input[name="pe_flavour"]:checked');
    local.set('pe_joined_flavour', flavour && FLAVOURS.includes(flavour.value) ? flavour.value : '');
    const name = form && form.querySelector('input[name="contact[first_name]"]');
    if (name) local.set('pe_joined_name', name.value.trim().slice(0, 40));
  }

  /* Countdown: <span data-pe-countdown="2026-11-13T09:00:00+03:00"> with [data-unit] children */
  function tick() {
    $$('[data-pe-countdown]').forEach((el) => {
      const target = Date.parse(el.dataset.peCountdown);
      if (Number.isNaN(target)) return;
      let ms = Math.max(0, target - Date.now());
      const d = Math.floor(ms / 864e5);
      ms -= d * 864e5;
      const h = Math.floor(ms / 36e5);
      ms -= h * 36e5;
      const m = Math.floor(ms / 6e4);
      ms -= m * 6e4;
      const s = Math.floor(ms / 1e3);
      const values = { d, h: String(h).padStart(2, '0'), m: String(m).padStart(2, '0'), s: String(s).padStart(2, '0') };
      $$('[data-unit]', el).forEach((u) => {
        u.textContent = values[u.dataset.unit];
      });
    });
  }
  tick();
  setInterval(tick, 1000);

  /* Waitlist forms: build contact[tags] from the base tag, the chosen flavour and the quiz match */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-pe-waitlist]');
    if (!form) return;
    const tagsInput = form.querySelector('[data-pe-tags]');
    const tags = [tagsInput.dataset.base || 'waitlist'];
    const flavour = form.querySelector('input[name="pe_flavour"]:checked');
    if (flavour && flavour.value) tags.push('flavour-' + flavour.value);
    const quiz = document.querySelector('[data-pe-quiz][data-match]');
    if (quiz) tags.push('quiz-' + quiz.dataset.match);
    // On the bundle page, save the picked bags with the signup: one tag per flavour, e.g. "bundle-banana-2"
    const bundleRoot = form.closest('[data-pe-bundle]');
    if (bundleRoot) {
      const picks = {};
      $$('[data-pe-brow]', bundleRoot).forEach((row) => {
        const n = parseInt(row.querySelector('output').value, 10) || 0;
        if (n > 0 && FLAVOURS.includes(row.dataset.key)) picks[row.dataset.key] = n;
      });
      Object.keys(picks).forEach((key) => tags.push(`bundle-${key}-${picks[key]}`));
      if (Object.keys(picks).length) local.set('pe_bundle', bundleString(picks));
    }
    if (tags[0] === 'waitlist') {
      tags.push('ref-' + myCode());
      if (referredBy()) tags.push('referred-by-' + referredBy());
      rememberJoin(form);
      session.set('pe_joining', '1');
    }
    tagsInput.value = tags.join(', ');
  });

  /* After a waitlist signup succeeds, Shopify reloads the page with the form's success state.
     Go on to the "You're on the list" page from there. */
  const joinedTarget = document.querySelector('[data-pe-joined-url]');
  if (joinedTarget && session.get('pe_joining')) {
    session.remove('pe_joining');
    local.set('pe_joined', '1');
    const query = new URLSearchParams({ code: myCode() });
    const flavour = local.get('pe_joined_flavour');
    if (flavour) query.set('f', flavour);
    window.location.replace(`${joinedTarget.dataset.peJoinedUrl}?${query}`);
  }

  /* WhatsApp option: open a chat with a ready-made message that names the chosen flavour */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pe-wa]');
    if (!link) return;
    const form = link.closest('form');
    const picked = form && form.querySelector('input[name="pe_flavour"]:checked');
    let text = link.dataset.waText;
    if (picked && picked.value && picked.dataset.name) text += ' ' + link.dataset.waFlavour.replace('%s', picked.dataset.name);
    if (link.dataset.waCode) text += ' ' + link.dataset.waCode.replace('%s', myCode());
    if (link.dataset.waRef && referredBy()) text += ' ' + link.dataset.waRef.replace('%s', referredBy());
    link.href = `https://wa.me/${link.dataset.waNumber}?text=${encodeURIComponent(text)}`;
    rememberJoin(form);
    local.set('pe_joined', '1');
    const done = link.parentElement.querySelector('[data-pe-wa-done]');
    if (done) done.hidden = false;
  });

  /* Full waitlist form as three short steps: flavour → email or WhatsApp → details.
     Clicking an option moves on; keyboard users use Next. Without JS everything shows at once. */
  $$('[data-pe-wl]').forEach((wl) => {
    const steps = $$('[data-pe-wl-step]', wl);
    const bar = wl.querySelector('[data-pe-wl-bar]');
    const back = wl.querySelector('[data-pe-wl-back]');
    const next = wl.querySelector('[data-pe-wl-next]');
    const dots = $$('[data-pe-wl-dot]', wl);
    dots.slice(steps.length).forEach((d) => d.remove());
    let current = 0;

    function go(index, focus) {
      current = index;
      steps.forEach((step, i) => step.classList.toggle('is-current', i === index));
      dots.forEach((d, i) => {
        d.classList.toggle('is-done', i < index);
        d.classList.toggle('is-current', i === index);
      });
      back.style.visibility = index === 0 ? 'hidden' : '';
      next.style.visibility = index === steps.length - 1 ? 'hidden' : '';
      if (!focus) return;
      const heading = $$('.pe-wl__q', steps[index]).find((q) => q.offsetParent !== null);
      if (heading) heading.focus({ preventScroll: true });
    }

    wl.classList.add('is-stepped');
    bar.hidden = false;
    go(0, false);
    wl.peGo = (index) => go(Math.min(index, steps.length - 1), true);

    wl.addEventListener('click', (event) => {
      if (event.target.closest('[data-pe-wl-back]')) {
        if (current > 0) go(current - 1, true);
        return;
      }
      if (event.target.closest('[data-pe-wl-next]')) {
        go(Math.min(current + 1, steps.length - 1), true);
        return;
      }
      // A click on an option's label (not the synthetic click on its hidden radio) moves on
      const option = event.target.closest('.pe-wl__flav, .pe-wl__skip, .pe-wl__channel');
      if (option && !event.target.matches('input') && steps[current].contains(option) && current < steps.length - 1) {
        setTimeout(() => go(current + 1, true), 150);
      }
    });
  });

  /* "You're on the list" page: name, flavour and pass number from the signup, and the share link */
  $$('[data-pe-joined]').forEach((root) => {
    // The code normally comes from this browser; the address only fills in when storage is off
    let code = local.get('pe_ref_code');
    if (!CODE.test(code)) code = (params.get('code') || '').toUpperCase();
    if (!CODE.test(code)) code = '';
    let flavour = params.get('f') || local.get('pe_joined_flavour');
    if (!FLAVOURS.includes(flavour)) flavour = '';
    const name = local.get('pe_joined_name');
    // Keep the code out of the address bar, so a copied address doesn't hand someone else this pass
    if (params.has('code') && window.history.replaceState) {
      const clean = new URL(window.location.href);
      clean.searchParams.delete('code');
      window.history.replaceState(null, '', clean);
    }

    const guest = root.querySelector('[data-pe-joined-guest]');
    if (guest && !code) {
      guest.hidden = false;
      $$('[data-pe-joined-intro]', root).forEach((el) => (el.hidden = true));
      root.classList.add('is-guest');
    }
    if (params.get('via') === 'wa') $$('[data-pe-joined-wa]', root).forEach((el) => (el.hidden = false));
    if (name) {
      $$('[data-pe-joined-name]', root).forEach((el) => (el.textContent = ', ' + name));
      $$('[data-pe-pass-name]', root).forEach((el) => (el.textContent = name));
    }
    if (code) $$('[data-pe-code]', root).forEach((el) => (el.textContent = code));
    if (flavour) {
      root.dataset.flavour = flavour;
      root.classList.add('has-pick');
    }
    $$('[data-pe-pick]', root).forEach((el) => (el.hidden = el.dataset.pePick !== flavour));
    $$('[data-pe-bag]', root).forEach((img) => img.classList.toggle('is-picked', img.dataset.peBag === flavour));

    const url = root.dataset.shareBase + (code ? `?ref=${code}` : '');
    const message = (root.dataset.message || '').replace('[link]', url);
    const input = root.querySelector('[data-pe-share-link]');
    if (input) input.value = url.replace(/^https?:\/\//, '');
    const wa = root.querySelector('[data-pe-share-wa]');
    if (wa) wa.href = `https://wa.me/?text=${encodeURIComponent(message)}`;
    const mail = root.querySelector('[data-pe-share-email]');
    if (mail) mail.href = `mailto:?subject=${encodeURIComponent(mail.dataset.subject)}&body=${encodeURIComponent(message)}`;
    const native = root.querySelector('[data-pe-share-native]');
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', () => {
        navigator.share({ title: native.dataset.title, text: message.replace(url, '').trim(), url }).catch(() => {});
      });
    }

    const copy = root.querySelector('[data-pe-copy]');
    const status = root.querySelector('[data-pe-copy-status]');
    if (copy && input) {
      const label = copy.textContent;
      copy.addEventListener('click', () => {
        const done = () => {
          copy.textContent = copy.dataset.done;
          copy.classList.add('is-done');
          if (status) status.textContent = root.dataset.copiedStatus || '';
          setTimeout(() => {
            copy.textContent = label;
            copy.classList.remove('is-done');
          }, 2200);
        };
        const fallback = () => {
          input.select();
          try {
            if (document.execCommand('copy')) done();
          } catch (e) {}
        };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(url).then(done, fallback);
        else fallback();
      });
      input.addEventListener('focus', () => input.select());
    }
  });

  /* Quiz intro "liquid throw": pour the splash in when the card scrolls into view.
     Without JS, or with reduced motion, it simply shows. */
  $$('[data-pe-splash]').forEach((splash) => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    splash.classList.add('is-armed');
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        splash.classList.add('is-poured');
        io.disconnect();
      },
      { threshold: 0.35 }
    );
    io.observe(splash);
  });

  /* Scroll reveal: section headings and blocks fade up as they come into view, and the cards in a
     grid follow each other. Anything already on screen at load is left alone, nothing is hidden
     without JS, and reduced motion skips it. Uses element.animate so it never fights an element's
     own CSS transitions. */
  (() => {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const GROUPS = '.pe-grid4, .pe-uses, .pe-steps, .pe-recipes, .pe-certs, .pe-perks, .pe-promises, .pe-tiers';
    const targets = new Set();
    $$('.pe-section:not(.pe-pdp)').forEach((section) => {
      $$('.pe-head', section).forEach((el) => targets.add(el));
      $$(GROUPS, section).forEach((group) => {
        // A row that scrolls sideways (cards on phones) comes in as one piece, so off-screen cards aren't left waiting
        if (group.scrollWidth > group.clientWidth + 4) targets.add(group);
        else [...group.children].forEach((el) => targets.add(el));
      });
      $$(':scope > .pe-wrap > *, :scope > .pe-social__row', section).forEach((el) => {
        if (el.matches('.pe-head') || el.matches(GROUPS) || el.querySelector(GROUPS) || el.querySelector('.pe-head')) return;
        targets.add(el);
      });
    });

    const io = new IntersectionObserver((entries) => {
      const entering = entries.filter((e) => e.isIntersecting).map((e) => e.target);
      entering.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top || a.getBoundingClientRect().left - b.getBoundingClientRect().left);
      entering.forEach((el, i) => {
        io.unobserve(el);
        el.classList.remove('pe-pre');
        el.animate(
          [{ opacity: 0, translate: '0 22px' }, { opacity: 1, translate: '0 0' }],
          { duration: 650, delay: Math.min(i * 70, 350), easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)', fill: 'backwards' }
        );
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    targets.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) return; // already in view: don't make it blink
      el.classList.add('pe-pre');
      io.observe(el);
    });
  })();

  /* Card in the mobile menu: close the menu, then scroll to the waitlist when it's on this page */
  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-pe-menu-cta]');
    if (!cta) return;
    const drawer = cta.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    const url = new URL(cta.href, window.location.href);
    const target = url.pathname === window.location.pathname && url.hash && document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 350);
  });

  /* "Notify me" buttons: jump to the waitlist form and pre-select the flavour */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pe-notify]');
    if (!trigger) return;
    const target = document.getElementById('pe-waitlist');
    if (!target) return;
    event.preventDefault();
    const flavour = trigger.dataset.peNotify;
    const radio = flavour && target.querySelector(`input[name="pe_flavour"][value="${flavour}"]`);
    if (radio) radio.checked = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const steps = target.querySelector('[data-pe-wl]');
    if (steps && steps.peGo) {
      setTimeout(() => steps.peGo(radio ? 1 : 0), 450);
      return;
    }
    const email = target.querySelector('input[type="email"]');
    if (email) setTimeout(() => email.focus({ preventScroll: true }), 450);
  });

  /* Recipe category filter */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pe-recfilter] [data-cat]');
    if (!btn) return;
    const bar = btn.closest('[data-pe-recfilter]');
    const list = bar.parentElement.querySelector('[data-pe-recipes]');
    const cat = btn.dataset.cat;
    $$('[data-cat]', bar).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    $$('.pe-recipe', list).forEach((r) => (r.hidden = cat !== 'all' && r.dataset.cat !== cat));
  });

  /* Product gallery: thumbnails, plus swiping left and right on the photo */
  function showSlide(gallery, index) {
    const slides = $$('.pe-gallery__main > img', gallery);
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    // Match photos by position: Shopify's image_tag doesn't always carry custom data attributes through
    slides.forEach((img, i) => img.classList.toggle('is-active', i === index));
    $$('[data-pe-thumb]', gallery).forEach((b, i) => {
      b.setAttribute('aria-current', String(i === index));
      if (i === index) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function stepSlide(gallery, dir) {
    const slides = $$('.pe-gallery__main > img', gallery);
    const current = slides.findIndex((img) => img.classList.contains('is-active'));
    showSlide(gallery, current + dir);
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-pe-thumb]');
    if (thumb) showSlide(thumb.closest('[data-pe-gallery]'), Number(thumb.dataset.peThumb));
    const arrow = event.target.closest('[data-pe-gal-dir]');
    if (arrow) stepSlide(arrow.closest('[data-pe-gallery]'), Number(arrow.dataset.peGalDir));
  });

  $$('[data-pe-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('.pe-gallery__main');
    if (!main) return;
    let startX = null;
    let startY = 0;
    main.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { startX = null; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      startX = null;
      // A sideways flick, not a page scroll
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      stepSlide(gallery, dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  /* Product form: quantity stepper and live price on the button */
  function formatMoney(cents, template) {
    const amount = (cents / 100).toLocaleString('en-KE', { maximumFractionDigits: 0 });
    return (template || 'KES {{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function refreshBuy(form) {
    const qtyInput = form.querySelector('[data-pe-qty]');
    const qty = Math.max(1, Math.min(9, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1));
    if (qtyInput) qtyInput.value = qty;
    const plan = form.querySelector('[data-pe-plan]:checked');
    const unit = parseInt(plan ? plan.dataset.price : form.dataset.price, 10);
    // Reminder-based Subscribe & save: only send the interval and the discount redirect when it's picked
    const sns = form.querySelector('[data-pe-sns-opts]');
    if (sns) {
      const on = Boolean(plan && plan.hasAttribute('data-pe-sns-pick'));
      sns.hidden = !on;
      $$('[data-pe-sns-input]', form).forEach((input) => { input.disabled = !on; });
    }
    const unitLabel = form.querySelector('[data-pe-unit]');
    if (unitLabel) unitLabel.textContent = qty === 1 ? unitLabel.dataset.one : unitLabel.dataset.other;
    const label = form.querySelector('[data-pe-total]');
    if (label && !Number.isNaN(unit)) label.textContent = formatMoney(unit * qty, form.dataset.moneyFormat);
    $$('[data-pe-step]', form).forEach((b) => {
      const dir = parseInt(b.dataset.peStep, 10);
      b.disabled = (dir < 0 && qty <= 1) || (dir > 0 && qty >= 9);
    });
  }

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-pe-step]');
    if (!step) return;
    const form = step.closest('[data-pe-buy]');
    const qtyInput = form.querySelector('[data-pe-qty]');
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.dataset.peStep, 10);
    refreshBuy(form);
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-pe-buy]');
    if (form) refreshBuy(form);
  });

  $$('[data-pe-buy]').forEach(refreshBuy);

  /* Flavour quiz: one question at a time, then the plan card for the best-scoring flavour */
  $$('[data-pe-quiz]').forEach((quiz) => {
    const intro = quiz.querySelector('[data-pe-quiz-intro]');
    const run = quiz.querySelector('[data-pe-quiz-run]');
    const questions = $$('[data-pe-q]', quiz);
    const dots = $$('[data-pe-step-dot]', quiz);
    const results = $$('[data-pe-result]', quiz);
    let step = 0;
    let picks = [];

    function focusHeading(root) {
      const heading = root && root.querySelector('h3');
      if (heading) heading.focus({ preventScroll: true });
    }

    function show(index) {
      step = index;
      questions.forEach((q, i) => {
        q.hidden = i !== index;
      });
      results.forEach((r) => {
        r.hidden = true;
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-done', i < index);
        d.classList.toggle('is-current', i === index);
      });
      $$('.pe-quiz__a', questions[index]).forEach((a) => {
        a.setAttribute('aria-pressed', String(Boolean(picks[index]) && picks[index].button === a));
      });
      focusHeading(questions[index]);
    }

    function finish() {
      const score = {};
      picks.forEach((pick, i) => {
        score[pick.flavour] = (score[pick.flavour] || 0) + (parseFloat(questions[i].dataset.weight) || 1);
      });
      const keys = results.map((r) => r.dataset.peResult);
      const best = keys.reduce((top, key) => ((score[key] || 0) > (score[top] || 0) ? key : top), keys[0]);
      step = questions.length;
      questions.forEach((q) => {
        q.hidden = true;
      });
      dots.forEach((d) => {
        d.classList.add('is-done');
        d.classList.remove('is-current');
      });
      $$('[data-pe-answer]', quiz).forEach((el) => {
        const pick = picks[parseInt(el.dataset.peAnswer, 10)];
        el.textContent = pick ? pick.label : '';
      });
      results.forEach((r) => {
        r.hidden = r.dataset.peResult !== best;
      });
      quiz.dataset.match = best;
      document.dispatchEvent(new CustomEvent('pe:flavour-match', { detail: best }));
      focusHeading(quiz.querySelector(`[data-pe-result="${best}"]`));
      const top = quiz.getBoundingClientRect().top;
      if (top < 0) quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    quiz.addEventListener('click', (event) => {
      if (event.target.closest('[data-pe-quiz-start]') || event.target.closest('[data-pe-quiz-restart]')) {
        picks = [];
        intro.hidden = true;
        run.hidden = false;
        show(0);
        return;
      }
      const answer = event.target.closest('.pe-quiz__a');
      if (answer) {
        picks[step] = { flavour: answer.dataset.flavour, label: answer.textContent.trim(), button: answer };
        if (step + 1 < questions.length) show(step + 1);
        else finish();
        return;
      }
      if (event.target.closest('[data-pe-quiz-back]')) {
        if (step === 0) {
          run.hidden = true;
          intro.hidden = false;
          const start = quiz.querySelector('[data-pe-quiz-start]');
          if (start) start.focus();
        } else {
          show(step - 1);
        }
      }
    });
  });

  /* Tabs ("ways to use it"): click or arrow keys; #key in the URL opens that tab */
  $$('[data-pe-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    function select(tab, focus) {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      select(tab);
      history.replaceState(null, '', '#' + tab.dataset.peTab);
    });
    root.addEventListener('keydown', (event) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const next = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      select(tabs[next], true);
    });
    function fromHash() {
      const tab = tabs.find((t) => '#' + t.dataset.peTab === window.location.hash);
      if (!tab) return;
      select(tab);
      root.scrollIntoView({ block: 'start' });
    }
    fromHash();
    window.addEventListener('hashchange', fromHash);
  });

  /* Shop row: arrow buttons scroll one tile; they switch off at either end */
  $$('[data-pe-track]').forEach((track) => {
    const root = track.closest('section');
    const prev = root.querySelector('[data-pe-track-prev]');
    const next = root.querySelector('[data-pe-track-next]');
    if (!prev || !next) return;
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300);
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Flavour table: move the highlighted column to the quiz match */
  document.addEventListener('pe:flavour-match', (event) => {
    $$('[data-pe-compare] [data-key]').forEach((cell) => {
      cell.classList.toggle('is-hl', cell.dataset.key === event.detail);
    });
  });

  /* "You're on the list" page: show the bundle they saved with their signup */
  $$('[data-pe-joined-bundle]').forEach((el) => {
    const picks = parseBundle(local.get('pe_bundle'));
    if (!picks) return;
    let names = {};
    try {
      names = JSON.parse(el.dataset.names);
    } catch (e) {}
    el.querySelector('[data-pe-joined-bundle-list]').textContent = Object.keys(picks)
      .map((key) => `${picks[key]}× ${names[key] || key}`)
      .join(', ');
    el.querySelector('[data-pe-joined-bundle-link]').href = `${el.dataset.url}?b=${encodeURIComponent(bundleString(picks))}`;
    el.hidden = false;
  });

  /* Bundle builder */
  $$('[data-pe-bundle]').forEach((root) => {
    const tiers = JSON.parse(root.dataset.tiers || '{}');
    const max = 4;
    const rows = $$('[data-pe-brow]', root);
    const money = root.dataset.moneyFormat;

    // Start from a bundle in the link (?b=banana:2,plain:1) or the one saved when they joined the waitlist
    const saved = parseBundle(params.get('b')) || parseBundle(local.get('pe_bundle'));
    if (saved) rows.forEach((r) => (r.querySelector('output').value = saved[r.dataset.key] || 0));

    function render() {
      const counts = rows.map((r) => parseInt(r.querySelector('output').value, 10) || 0);
      const n = counts.reduce((a, b) => a + b, 0);
      const subtotal = rows.reduce((sum, r, i) => sum + counts[i] * parseInt(r.dataset.price, 10), 0);
      const pct = tiers[n] || 0;
      const saving = Math.round((subtotal * pct) / 100);
      rows.forEach((r, i) => {
        r.querySelector('[data-dir="-1"]').disabled = counts[i] <= 0;
        r.querySelector('[data-dir="1"]').disabled = n >= max;
      });
      $$('.pe-tiers span', root).forEach((s) => s.classList.toggle('is-active', parseInt(s.dataset.n, 10) === n));
      root.querySelector('[data-sum="count"]').textContent = n === 1 ? root.dataset.oneBag : root.dataset.bags.replace('[n]', n);
      root.querySelector('[data-sum="subtotal"]').textContent = formatMoney(subtotal, money);
      const savingEl = root.querySelector('[data-sum="saving"]');
      if (savingEl) savingEl.textContent = saving ? '− ' + formatMoney(saving, money) : '—';
      root.querySelector('[data-sum="total"]').textContent = formatMoney(subtotal - saving, money);
      // Without bundle savings there's no minimum: any 1 to 4 bags
      const discounted = Object.values(tiers).some((p) => p > 0);
      const min = discounted ? 2 : 1;
      let hint;
      if (discounted) {
        hint = root.dataset.hintMin;
        if (n >= 2 && n < max) hint = root.dataset.hintNext.replace('[p]', tiers[n + 1]);
        if (n >= max) hint = root.dataset.hintBest;
      } else {
        hint = n >= max ? root.dataset.hintFull : n === 0 ? root.dataset.hintPick : '';
      }
      root.querySelector('[data-sum="hint"]').textContent = hint;
      root.querySelector('[data-sum="picked"]').innerHTML = rows
        .flatMap((r, i) => Array(counts[i]).fill(r.querySelector('template[data-thumb]').innerHTML.trim()))
        .join('');
      const add = root.querySelector('[data-pe-bundle-add]');
      if (add) add.disabled = n < min;
    }

    root.addEventListener('click', async (event) => {
      const btn = event.target.closest('[data-dir]');
      if (btn) {
        const out = btn.closest('[data-pe-brow]').querySelector('output');
        out.value = Math.max(0, (parseInt(out.value, 10) || 0) + parseInt(btn.dataset.dir, 10));
        render();
        return;
      }
      const add = event.target.closest('[data-pe-bundle-add]');
      if (add) {
        const items = rows
          .map((r) => ({ id: parseInt(r.dataset.variant, 10), quantity: parseInt(r.querySelector('output').value, 10) || 0 }))
          .filter((i) => i.id && i.quantity > 0);
        if (!items.length) return;
        add.disabled = true;
        try {
          const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        } catch (e) {
          add.disabled = false;
          const hint = root.querySelector('[data-sum="hint"]');
          hint.textContent = root.dataset.error;
        }
      }
    });

    render();
  });

  /* No single word alone on the last line: tie the last two words of each paragraph together.
     (CSS text-wrap: pretty does this in some browsers only, and not for short texts.) */
  $$('.pe p, .pe li, .pe dd, .pe figcaption').forEach((el) => {
    if (el.querySelector('p, li, ul, ol, div') || el.textContent.trim().split(/\s+/).length < 3) return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let last = null;
    for (let n = walker.nextNode(); n; n = walker.nextNode()) if (n.data.trim()) last = n;
    if (last) last.data = last.data.replace(/\s+(\S+\s*)$/, '\u00a0$1');
  });

  /* Two-sentence headings ("Four flavours. One simple powder.") and the hero's two lines: each part
     gets a line of its own and never breaks. If the longest line doesn't fit, the heading shrinks
     until it does. Headings that are one sentence split in two ("Which flavour / is yours?") wrap
     as usual. */
  const lineHeadings = [];
  $$('.pe h1, .pe h2').forEach((h) => {
    const accent = h.querySelector(':scope > .pe-accent');
    if (!accent) return;
    const before = [];
    for (let n = h.firstChild; n && n !== accent; n = n.nextSibling) before.push(n);
    const hasBreak = before.some((n) => n.nodeName === 'BR');
    const lead = before.map((n) => n.textContent).join('').trim();
    if (!lead || !(hasBreak || /[.!?]$/.test(lead))) return;
    const line = document.createElement('span');
    line.className = 'pe-line';
    before.forEach((n) => (n.nodeName === 'BR' ? n.remove() : line.appendChild(n)));
    line.textContent = line.textContent.trim();
    h.insertBefore(line, accent);
    h.classList.add('pe-lines');
    lineHeadings.push(h);
  });

  function fitLines() {
    lineHeadings.forEach((h) => {
      h.style.fontSize = '';
      const room = h.clientWidth;
      const widest = Math.max(...Array.from(h.children).map((c) => c.scrollWidth));
      if (room && widest > room) {
        h.style.fontSize = (parseFloat(getComputedStyle(h).fontSize) * room) / widest - 0.5 + 'px';
      }
    });
  }

  if (lineHeadings.length) {
    let frame = 0;
    const refit = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fitLines);
    };
    fitLines();
    if (document.fonts) document.fonts.ready.then(refit);
    window.addEventListener('resize', refit);
  }

  /* Social proof row: arrows scroll by one card; videos loop silently only while on screen,
     and not at all for people who prefer reduced motion */
  $$('[data-pe-social]').forEach((root) => {
    const row = root.querySelector('[data-pe-social-row]');
    const arrows = $$('[data-pe-social-dir]', root);
    const step = () => {
      const card = row.querySelector('.pe-social__card');
      return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
    };
    const update = () => {
      arrows.forEach((a) => {
        const back = a.dataset.peSocialDir === '-1';
        a.disabled = back ? row.scrollLeft < 4 : row.scrollLeft + row.clientWidth > row.scrollWidth - 4;
      });
    };
    arrows.forEach((a) => a.addEventListener('click', () => row.scrollBy({ left: step() * parseInt(a.dataset.peSocialDir, 10), behavior: 'smooth' })));
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    const videos = $$('[data-pe-social-video]', root);

    // Sound button: one clip with sound at a time, started from the beginning so speech makes sense
    const setSound = (btn, on) => {
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? btn.dataset.off : btn.dataset.on);
    };
    $$('[data-pe-social-sound]', root).forEach((btn) => {
      const video = btn.parentElement.querySelector('[data-pe-social-video]');
      if (!video) return;
      btn.addEventListener('click', () => {
        const on = video.muted;
        $$('[data-pe-social-sound]', root).forEach((other) => {
          const v = other.parentElement.querySelector('[data-pe-social-video]');
          if (v && v !== video) { v.muted = true; setSound(other, false); }
        });
        video.muted = !on;
        setSound(btn, on);
        if (on) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      });
      // A clip that scrolls away is paused; show it as muted again so the next play starts silently
      video.addEventListener('pause', () => {
        if (!video.muted && !video.ended) { video.muted = true; setSound(btn, false); }
      });
    });

    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !videos.length) {
      videos.forEach((v) => { v.preload = 'metadata'; });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      videos.forEach((v) => { v.autoplay = true; v.play().catch(() => {}); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.play().catch(() => {});
        else e.target.pause();
      });
    }, { threshold: 0.4 });
    videos.forEach((v) => io.observe(v));
  });
})();
